<template>

</template>

<script>
// All deployed clients use the project's HTTPS entry point. The server
// proxies only /words/ to Django, keeping the API on the same trusted origin.
const REMOTE_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://www.tianjinwords.top/words'
const { protocol, hostname } = window.location
const capacitor = window.Capacitor
const isNativeApp = capacitor &&
    typeof capacitor.isNativePlatform === 'function' &&
    capacitor.isNativePlatform()

// Capacitor 真机页面的主机是 localhost，不能把它当成 API 服务器。
// Keep local browser development available, while deployed web and native
// builds consistently use the HTTPS API above.
const isLocalDevelopment =
    !isNativeApp && (hostname === 'localhost' || hostname === '127.0.0.1')
// In local development, go through the Vue dev-server proxy so the browser
// stays on the 8080 origin and does not trigger CORS checks against Django.
const BASE_URL = isLocalDevelopment
    ? '/api/words'
    : REMOTE_BASE_URL
export default {
  BASE_URL
}

// nvm use 21
// export NODE_OPTIONS=--openssl-legacy-provider
// npm run serve
// npm run build
</script>

<style scoped>

</style>
